export default function PRReportPackageSummariesController() {
  /* provided only for controllerAs binding */
}
